<template>
<div class="page page_income page_tixianlist">
    <div class="list">
        <div class="order">
            <div class="item" v-for="withdraw in dataList" :key="withdraw.id">
                <div class="item_l">
                    <div class="bianhao">{{ withdraw.title }}</div>
                    <div class="time">{{ withdraw.date }}</div>
                </div>
                <div class="item_r price"><span class="tag_cash">¥</span>{{ withdraw.price ? withdraw.price : 0 }}</div>
            </div>
        </div>
    </div>
    <!-- 列表 -->
    <!-- <div class="jiangren">
        <div class="con" v-for="withdraw in dataList" :key="withdraw.id">
            <div class="con_info clearfix">
                <div class="f-l con_info_r">
                    <div class="name">{{ withdraw.title }}</div>
                    <div class="name">{{ withdraw.price }}</div>
                    <div class="name">{{ withdraw.date }}</div>
                </div>
            </div>
        </div>
    </div> -->
</div>
</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            token: null,
            dataList: []
        };
    },

    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            this.isClient = true
            var params = {
                data: {
                    naviTitle: "提现明细"
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, data => {});
            //加载用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log(data)
                console.log('111')
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback('refresh success')
            })
        } else {
            this.isClient = false
            // 获取列表
            this.token = this.$store.getters.token
            this.getData();
        }
    },
    methods: {
        // 获取列表
        getData() {
            var param = {
                token: this.token
            }
            this.$api.my.withdrawList(param).then(res => {
                if (res.code == 200) {
                    this.dataList = res.result
                } else {
                    this.$toast(res.message)
                }
            })
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
